import { render, staticRenderFns } from "./AddExcel.vue?vue&type=template&id=889de10a&scoped=true&"
import script from "./AddExcel.vue?vue&type=script&lang=js&"
export * from "./AddExcel.vue?vue&type=script&lang=js&"
import style0 from "./AddExcel.vue?vue&type=style&index=0&id=889de10a&prod&scoped=true&lang=css&"
import style1 from "./AddExcel.vue?vue&type=style&index=1&id=889de10a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889de10a",
  null
  
)

export default component.exports